import { gql } from '@apollo/client';

export const CREATE_EDITOR_CANVAS = gql`
  mutation CreateEditorCanvas($fields: CreateEditor_canvasFieldsInput) {
    createEditor_canvas(input: { fields: $fields }) {
      editor_canvas {
        objectId
      }
    }
  }
`;

export const UPDATE_EDITOR_CANVAS = gql`
  mutation UpdateEditorCanvas(
    $id: ID!
    $fields: UpdateEditor_canvasFieldsInput
  ) {
    updateEditor_canvas(input: { id: $id, fields: $fields }) {
      editor_canvas {
        objectId
      }
    }
  }
`;

export const GET_EDITOR_CANVAS_BY_ID = gql`
  query GetEditorCanvasById($id: ID!) {
    getEditorCanvas(id: $id) {
      objectId
      status
      metadata
      defunto_pointer {
        objectId
        nome
        cognome
        soprannome
        data_morte
        data_nascita
        data_funerale
        data_trasporto
        data_chiusura_feretro
        sesso
        luogo_decesso
        nome_struttura
        luogo_morte
        indirizzo_morte
        partenza
        stato_civile_nome
        stato_civile
        residenza
        forno
        cimitero
        metadata
        company_pointer {
          objectId
          alias
          cap_fatturazione
          citta_fatturazione
          codice_destinatario
          codice_fiscale
          colore_principale
          colore_secondario
          colore_testo
          colore_testo_intestazione
          cover_image {
            url
            name
          }
          email_fatturazione
          enabled
          fatturazione_elettronica
          iban
          indirizzo_fatturazione
          intestatario_banca
          nome
          nome_banca
          partita_iva
          pec
          provincia_fatturazione
          ragione_sociale
          regime_fiscale
          sito
          slug
          logo {
            url
            name
          }
          logo_completo {
            url
            name
          }
          logo_sito {
            url
            name
          }
          timbro {
            url
            name
          }
        }
        office_pointer {
          objectId
          cap
          cellulare1
          cellulare2
          citta
          email
          enabled
          frazione
          indirizzo
          name
          nascondi
          pec
          provincia
          telefono1
          telefono2
          logo {
            url
            name
          }
          logo_completo {
            url
            name
          }
          logo_sito {
            url
            name
          }
          funeral_home_pointer {
            objectId
            name
            alias
          }
          company_pointer {
            objectId
            alias
            cap_fatturazione
            citta_fatturazione
            codice_destinatario
            codice_fiscale
            colore_principale
            colore_secondario
            colore_testo
            colore_testo_intestazione
            cover_image {
              url
              name
            }
            email_fatturazione
            enabled
            fatturazione_elettronica
            iban
            indirizzo_fatturazione
            intestatario_banca
            nome
            nome_banca
            partita_iva
            pec
            provincia_fatturazione
            ragione_sociale
            regime_fiscale
            sito
            slug
            logo {
              url
              name
            }
            logo_completo {
              url
              name
            }
            logo_sito {
              url
              name
            }
            timbro {
              url
              name
            }
          }
        }
        chiese_pointer {
          nome
          citta
          frazione
          indirizzo
        }
        allegati_pointer {
          objectId
          isRemovebg
          isBlurBg
          provino
          mimeType
          allegato {
            url
            name
          }
        }
        relation_necrofori {
          edges {
            node {
              objectId
              nome
              cognome
              cellulare
              codice_fiscale
              data_nascita
              indirizzo_residenza
              firma {
                name
                url
              }
              ruolo
              email
            }
          }
        }
        struttura_trasferimento_pointer {
          objectId
          nome
          citta
          numero
          cap
          note
          indirizzo
          provincia
          frazione
          tipologia_struttura
        }
      }
      editor_canvas_pages(first: 100) {
        count
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            objectId
            order
            canvasJson
            animations
            soundtrackId
            gifPreviewId
            preview {
              name
              url
            }
            createdAt
            updatedAt
          }
        }
      }
      editor_project_types_pointer {
        objectId
        griglia_provino
        multiplier
        isRelatedToFuneral
        name
        order
        outputDpi
        loadReservationImages
      }
      editor_project_formats_default_pointer {
        objectId
        width
        height
        name
        unit
        generico
        dpi
        isGlobal
        minimum_border
        orientation
      }
      editor_project_formats_pointer {
        objectId
        width
        height
        orientation
        unit
        dpi
        isCustom
        name
        multiplier
        editor_project_formats_default_pointer {
          objectId
          width
          height
          name
          unit
          generico
          dpi
          isGlobal
          minimum_border
          orientation
        }
      }
      editor_project_types_default_pointer {
        objectId
        isGlobal
        name
        griglia_provino
        order
        outputDpi
        multiplier
        isRelatedToFuneral
        allowCustomFormats
        loadReservationImages
      }
      editor_templates_categories_default_pointer {
        objectId
        name
        order
        isGlobal
        annunciFunebri
        img {
          url
        }
        img_verticale {
          url
        }
      }
      editor_templates_categories_pointer {
        objectId
        name
        order
        isRelatedToFuneral
      }
      editor_templates_pointer {
        objectId
        name
      }
      editor_templates_default_pointer {
        objectId
        name
      }
    }
  }
`;

export const GET_EDITOR_CANVAS_PAGES_PAGINATED = gql`
  query GetEditorCanvasPagesPaginated($id: ID!, $limit: Int!, $after: String) {
    getEditorCanvas(id: $id) {
      editor_canvas_pages(first: $limit, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            objectId
            order
            canvasJson
            animations
            soundtrackId
            gifPreviewId
            preview {
              name
              url
            }
            createdAt
            updatedAt
          }
        }
      }
    }
  }
`;
